<template>
    <!-- order form modal -->
    <div id="customConfirmationDialog" v-if="isOrderFormModalOpen">
        <div @click="() => changeOrderModalState(false) && isNewOrder === true && isOrderFormModalOpen === false ? quantity = 1 : quantity = parseInt(this.QuantityBeforeEdit, 10)"
            :class="`modal-backdrop ${isOrderFormModalOpen ? '' : 'hidden'}`">
        </div>
        <div id="popupModal" tabindex="-1">
            <!-- modal body -->
            <div class="fixed top-0 right-0 z-[150] h-full sm:w-full w-[90%] max-w-xl max-h-full">
                <div class="relative bg-white modal_inner_dialog h-full flex flex-col">
                    <img  @click="() => changeOrderModalState(false) && this.$destroy() && isOrderFormModalOpen === false" class="w-[22px] h-[22px] block absolute left-4 top-4 cursor-pointer" src="../../../assets/icons/times.svg" alt="">
                    <div >
                        <Breadcrumb :links="breadcrumbLinks" />
                    </div>
                    <h1 v-if="isNewOrder && !this.$route.query.productItem" 
                        class="text-xl font-bold p-4 md:p-6 text-gray-800 border-b border-gray-200">
                        <span class="mr-2">{{ $t('general.order_details') }}:</span>
                        <span class="text-primary">
                            {{ 
                            productData.product_type === 'wholesale' ? 
                            totalPriceWolesale :
                            totalPriceRetail === -1 ? this.$t('general.according_agreement') : 
                            totalPriceRetail === 0 ? this.$t('general.free') :  
                            totalPriceRetail != 'N/A' ? totalPriceRetail + ' ' + $t('general.pound') : ''
                            }}
                        </span>
                    </h1>
                    <h1 v-else 
                        class="text-xl font-bold p-4 md:p-6 text-gray-800 border-b border-gray-200">
                        {{ $t('general.order_details') }}
                    </h1>
                    <div class="flex items-center gap-6 p-5 rounded-xl m-4 bg-[#f3f4f6] hover:bg-[#ebedf0] transition-colors">
                        <div class="relative">
                            <img 
                                :src="productImage !== null ? productImage : productData.image" 
                                class="w-28 h-28 object-contain rounded-xl shadow-md bg-white p-3 transition-transform hover:scale-105" 
                                :alt="currentLanguage === 'ar' ? productData.name_ar : productData.name_en"
                                @error="onImageError"
                            >
                            
                        </div>
                        <div class="flex flex-col flex-1">
                            <h3 class="text-base font-semibold text-gray-800 mb-2">
                                {{ currentLanguage === 'ar' ? 
                                    productName !== null ? productName : productData.name_ar : 
                                    productName !== null ? productName : productData.name_en 
                                }}
                            </h3>
                           
                        </div>
                    </div>
                    <div class="flex-grow overflow-auto px-6 py-4 md:px-7">
                        <form @submit.prevent="() => makeOrder()">
                            <div >
                                <div class="mt-2">
                                    <label class="text-black inline-block text-[12px] md:text-[13.5px] mb-1.5"
                                        for="quantity">
                                        {{$t('general.num_pieces') }}
                                            </label>

                                    <div class=" relative max-w-[280px] w-full h-[50px] flex">
                                        <button @click="increaseQuantity"
                                            class=" rounded-[11px] text-[24px] absolute bg-white top-0 right-0 z-10 border border-[#E5E5E5] h-[50px] w-[50px] flex items-center justify-center">+</button>
                                        <input @input="validateQuantity" type="number" v-model="quantity" min="1"
                                            class="w-full border border-[#E5E5E5] rounded-[11px] text-center flex items-center justify-center text-[24px] focus:border-[#E5E5E5] focus:outline-none">
                                        <button @click="decreaseQuantity"
                                            class=" absolute top-0 text-[24px] left-0 z-10 bg-[#E5E5E5] rounded-[11px] h-[50px] w-[50px] flex items-center justify-center">-</button>
                                    </div>
                                </div>
                                <div class="mt-6">
                                    <!-- <h5 class="text-black text-[12px] md:text-[13.5px] mb-1.5 pb-2 border-b">{{ $t('general.select_specifications') }}</h5> -->
                                    <div>
                                        <!-- For the Add Quantity -->
                                        <div v-if="isNewOrder === true && !this.$route.query.productItem" :class="`mt-6 mb-4 pb-4 border-b-[2px] ${visibleAttributes.length == (idx+1) && 'border-none'}`" v-for="(main, idx) in visibleAttributes" :key="idx">
                                            <label v-if="currentLanguage === 'ar'" class="mb-4 block text-[#6A6A6A]" :id="`${main.name_ar.split('-')[0]}`">{{ main.name_ar.split('-')[0] }} :</label>
                                            <label v-else class="mb-4 block text-[#6A6A6A]" :id="`${main.name_en.split('-')[0]}`">{{ main.name_en.split('-')[0] }} :</label>
                                            <ul class="flex flex-wrap gap-[20px]">
                                                <li v-for="(sub, i) in main.children" :key="i">
                                                    <span v-if="sub.color != null" @click="changeSelect(main.id, sub.id)" :class="`cursor-pointer block h-[50px] w-[50px] rounded-[15px] p-2 ${ sub.isSelected ? 'border border-[#956113] border-[3px]' : 'border border-gray-300 border-[1px]'}`" :style="{ backgroundColor: sub.color }"></span>

                                                    <span v-else-if="main.display_as_text === 0" @click="changeSelect(main.id, sub.id)" :class="`${sub.isSelected ? 'bg-[#0963FF] text-white' : 'border-[#a5a5a5] border-[1px]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px] text-center`">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                                    
                                                    <span class="bg-primaryLight3 text-primary py-[0.220rem] px-2 rounded-[0.375rem]" v-else >{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span> <!-- Display as text normally -->
                                                </li>
                                            </ul>
                                            <!-- Add error message -->
                                            <p v-if="main.showError" class="text-red-500 text-sm mt-2">
                                                {{ $t('general.please_select_attribute', { attribute: currentLanguage === 'ar' ? main.name_ar : main.name_en }) }}
                                            </p>
                                        </div>
                                        <!-- For the Edit Prodct -->
                                        <div v-if="isNewOrder === false && !this.$route.query.productItem" :class="`mt-6 mb-4 pb-4 border-b-[2px]`">
                                            <!-- <label v-if="currentLanguage === 'ar'" class="mb-4 block text-[#6A6A6A]">{{ main.name_ar }} :</label>
                                            <label v-else class="mb-4 block text-[#6A6A6A]">{{ main.name_en }} :</label>
                                            <ul class="flex flex-wrap gap-[20px]">
                                                <li v-for="(sub, i) in main.children" :key="i">
                                                    <span v-if="sub.color !== null" @click="changeSelectForEdit(main.id, sub.id)" :class="`cursor-pointer block h-[50px] w-[50px] rounded-[11px] p-2 ${ sub.isSelected || sub.is_selected || (sub.is_selected === true && sub.isSelected === true) ? 'border border-primary' : ''}`" :style="{ backgroundColor: sub.color }"></span>
                                                    <span v-else-if="main.display_as_text === 0 && currentLanguage === 'ar'" @click="changeSelectForEdit(main.id, sub.id)" :class="`${sub.isSelected || sub.is_selected || (sub.is_selected === true && sub.isSelected === true) ? 'border-primary' : 'border-[#C1C1C1]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px]`">{{ sub.name_ar }}</span>
                                                    <span v-else-if="main.display_as_text === 0 && currentLanguage === 'en'" @click="changeSelectForEdit(main.id, sub.id)" :class="`${sub.isSelected || sub.is_selected || (sub.is_selected === true && sub.isSelected === true) ? 'border-primary' : 'border-[#C1C1C1]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px]`">{{ sub.name_en }}</span>
                                                    <span v-else class="bg-primaryLight3 text-primary py-[0.220rem] px-2 rounded-[0.375rem]">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                                </li>
                                            </ul> -->
                                            <span class="text-[#6A6A6A] font-semibold text-[12px] md:text-[13.5px]">{{ $t('general.specifications_description') }}</span>
                                        </div>
                                        <!-- For the Edit Order From the cart -->
                                        <div v-if="this.$route.query.productItem" :class="`mt-6 mb-4 pb-4 border-b-[2px] ${visibleAttributes.length === (idx + 1) && 'border-none'}`" v-for="(main, idx) in visibleAttributes" :key="idx">
                                            <label v-if="currentLanguage === 'ar'" class="mb-4 block text-[#6A6A6A]">{{ main.name_ar.split('-')[0] }} :</label>
                                            <label v-else class="mb-4 block text-[#6A6A6A]">{{ main.name_en.split('-')[0] }} :</label>
                                            <ul class="flex flex-wrap gap-[20px]">
                                                <li v-for="(sub, i) in main.children" :key="i">
                                                    <!-- getOrderData?.attributes?.find(attr => attr.id === sub.id) -->
                                                    <span v-if="sub.color !== null" @click="changeSelectForEdit(main.id, sub.id)" :class="`cursor-pointer block h-[50px] w-[50px] rounded-[11px] p-2 ${sub.isSelected || (sub.is_selected === true && sub.isSelected === true) ? 'border border-[#956113] border-[3px]' : ''}`" :style="{ backgroundColor: sub.color }"></span>
                                                    <span v-else-if="main.display_as_text === 0 && currentLanguage === 'ar'" @click="changeSelectForEdit(main.id, sub.id)" :class="`${sub.isSelected || (sub.is_selected === true && sub.isSelected === true) ? 'bg-[#0963FF] text-white' : 'border-[#a5a5a5] border-[1px]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px]`">{{ sub.name_ar }}</span>
                                                    <span v-else-if="main.display_as_text === 0 && currentLanguage === 'en'" @click="changeSelectForEdit(main.id, sub.id)" :class="`${sub.isSelected || (sub.is_selected === true && sub.isSelected === true) ? 'bg-[#0963FF] text-white' : 'border-[#a5a5a5] border-[1px]'} border h-[50px] flex items-center px-4 cursor-pointer min-w-[60px] rounded-[11px]`">{{ sub.name_en }}</span>
                                                    <span v-else class="bg-primaryLight3 text-primary py-[0.220rem] px-2 rounded-[0.375rem]">{{ currentLanguage === 'ar' ? sub.name_ar : sub.name_en }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="border-t-2 mt-auto p-4 md:p-6">
                        <div class="flex flex-col sm:flex-row gap-4 justify-end items-center">
                            <span v-if="attributes_price > 0" 
                                  class="text-[15px] text-normal text-center w-full text-red-500">
                                {{ $t('general.note_order_details') }}
                            </span>
                            <button type="button" 
                                    @click="() => changeOrderModalState(false) && this.$destroy() && isOrderFormModalOpen === false"
                                    class="px-6 py-3 border border-primary text-primary rounded-md w-full sm:w-auto hover:bg-primary hover:text-white transition-colors">
                                <span class="flex items-center justify-center gap-2">
                                    <img src="../../../assets/icons/down.svg" 
                                         alt=""
                                         class="rotate-[270deg] w-5 h-4 object-contain">
                                    {{ $t("general.return") }}
                                </span>
                            </button>
                            <button ref="confirmOrderButton" @click="createOrderDetails()" 
                                    class="px-6 py-3 bg-primary text-white font-semibold rounded-md w-full sm:w-auto hover:opacity-90 transition-opacity">
                                {{ actualFromCartBoolean ? $t('general.confirm_add_to_cart') : this.$route.query.productItem ? $t('general.edit') : $t('general.confirm_order') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { helpers } from "@vuelidate/validators";
import timesIcon from "@/assets/icons/times_red.svg";
import { APIREQUESTS, MAINROLES, constructQueryString, getPriceAfterDiscount } from "@/helpers";
import { Modal , Breadcrumb } from "@/components";
import { useGlobalStore } from "@/store/Modules/global";

export default {
    components:{
        Breadcrumb,
    },
    data() {
        return {
            totalPriceRetail: 'N/A',
            totalPriceWolesale: 'N/A',
            attributes_price: 'N/A',
            priceRetail: 'N/A',
            fromCart: false,
            priceWholesale: 'N/A',
            productDiscount: 'N/A',
            timesIcon,
            orderID: this.orderID,
            quantity: this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10),
            quantityEdited: parseInt(this.QuantityBeforeEdit, 10),
            globalStore: useGlobalStore(),
            currentLanguage: this.globalStore?.localStorageCopy?.language || 'ar',
            attributes: [],
            orderDetailsData: [],
            getOrderData: null,
            productName: null,
            productImage: null,
            productItem: null,
            minQuantity: this.minQuantity || 1,
            cartID: null,
            attributesCart: [],
            isOrderFormModalOpen: false,
            branchDiscount: 0,
            basic_price: 0,
            totalPriceWolesale: 0,
            attributes_price: 0,
            priceRetail: 0,
            fromCart: false,
            priceWholesale: 0,
            productDiscount: 0,
        }
    },
    props: {
        QuantityBeforeEdit: {
            type: Number,
            default: 1,
            required: false
        },
        isOrderFormModalOpen: {
            type: Boolean,
            default: false,
            required: true
        },
        isNewOrder: {
            type: Boolean,
            default: false,
            required: false
        },
        changeOrderModalState: {
            type: Function,
            required: true
        },
        productData: {
            type: Object,
            default: {},
            required: false
        },
        orderData: {
            type: Object,
            default: {},
            required: false
        },
        editedOrder: {
            type: Object,
            default: {},
            required: false
        },
        branchData: {
            type: Object,
            default: {},
            required: false
        },
        fromCartBoolean: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        breadcrumbLinks() {
      return [
        { text: this.$t("Breadcrumb.home"), path: "/" },
        { text: this.$t("Breadcrumb.enter_order_details"), path: "" },
      ];
    },
    // Filter attributes to show only those with more than one child
    visibleAttributes() {
      return this.attributes.filter(attr => attr.children && attr.children.length > 1);
    },
    // Get fromCartBoolean from prop or localStorage
    actualFromCartBoolean() {
      if (this.fromCartBoolean) {
        return true;
      }
      const fromCartStorage = localStorage.getItem('fromCart');
      // Handle string 'true' from localStorage, or boolean true from prop
      if (fromCartStorage === 'true' || fromCartStorage === true) {
        return true;
      }
      // Explicitly return false for 'false' string or null/undefined
      return false;
    },
    },
    methods: {
        validateAndScrollToAttribute(attribute) {
            // Find the attribute element by its label
            const attributeLabel = this.currentLanguage === 'ar' ? attribute.name_ar : attribute.name_en;
            const element = document.getElementById(attributeLabel);
            
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
                // Set error flag for this attribute
                attribute.showError = true;
            }
        },
        validateAllAttributesSelected() {
            let isValid = true;
            
            // Reset all error states first
            this.attributes.forEach(attr => {
                attr.showError = false;
            });
            
            for (const attribute of this.attributes) {
                // Skip attributes with display_as_text = 1
                if (attribute.display_as_text === 1) {
                    continue;
                }

                const selectedChildren = attribute.children.filter(child => 
                    child.isSelected || child.is_selected || (child.is_selected === true && child.isSelected === true)
                );

                // If there's only one child, select it automatically
                if (attribute.children.length === 1 && selectedChildren.length === 0) {
                    this.changeSelectForEdit(attribute.id, attribute.children[0].id);
                    continue;
                }

                // If no selection made and multiple children exist
                if (selectedChildren.length === 0 && attribute.children.length > 1) {
                    this.validateAndScrollToAttribute(attribute);
                    isValid = false;
                }
            }

            return isValid;
        },
        getProductImage(){
            if(!this.$route.query.productItem){
                return this.productData.image
            }else{
                return this.productItem.product.image
            }
        },
        getProductName(){
            if(!this.$route.query.productItem){
                return this.currentLanguage === 'ar' ? this.productData.name_ar : this.productData.name_en 
            }else{
                return this.currentLanguage === 'ar'? this.productItem.product.name_ar : this.productItem.product.name_en
            }
        },
        calculateTotalPriceWholesale(){

            if (this.branchData?.id) {
                this.branchDiscount = (parseFloat(this.branchData?.discount) / 100).toFixed(2);
            } else {
                if(localStorage.getItem('branch') !== "main"){
                    this.branchDiscount = (parseFloat(JSON.parse(localStorage.getItem('branch')).discount) / 100).toFixed(2);
                }else{
                    this.branchDiscount = 0;
                }
            }
            const activeWholesaleDetail = this.productData?.wholesale_details?.find(detail => detail.from_quantity <= this.quantity && detail.to_quantity >= this.quantity || detail.from_quantity <= this.quantity && detail.to_quantity === -1);
            this.basic_price = parseFloat(activeWholesaleDetail?.price);
            if(this.productData.discount){
                this.basic_price = this.basic_price * (1 - parseFloat(this.productData.discount) / 100).toFixed(2);
            }
            if(this.branchDiscount !== 0){
                this.basic_price = this.basic_price * (1 - this.branchDiscount);
            }
            const total = (this.basic_price) * this.quantity;
            this.totalPriceWolesale = Math.ceil(total);
            return this.totalPriceWolesale;
        },
        calculateTotalPrice(){
            // Get the branch discount
            
            if (this.branchData?.id) {
                this.branchDiscount = (parseFloat(this.branchData?.discount) / 100).toFixed(2);
            } else {
                if(localStorage.getItem('branch') !== "main"){
                    this.branchDiscount = (parseFloat(JSON.parse(localStorage.getItem('branch')).discount) / 100).toFixed(2);
                }else{
                    this.branchDiscount = 0;
                }
            }
            // Get the basic price of the product
            this.basic_price = parseFloat(this.productData?.basic_price);
            if(parseInt(this.basic_price) === -1){
                this.totalPriceRetail = -1;
                return this.totalPriceRetail
            }else if(parseInt(this.basic_price) === 0){
                this.totalPriceRetail = 0;
                return this.totalPriceRetail
            }
            // // Apply product discount if applicable
            // if (this.productData?.discount !== 0) {
            //     this.basic_price *= (1 - (this.productData.discount / 100));
            // }
            // Get the attributes price
            this.attributes_price = this.getSelectedAttributes().reduce((total, attribute) => {
                return total + attribute?.children.reduce((subTotal, child) => {
                    return subTotal + (child?.price ? parseFloat(child.price) : 0);
                }, 0);
            }, 0);

            // Calculate total price before applying discounts
            let totalBeforeDiscounts = this.basic_price + this.attributes_price;
            // Apply product discount if applicable
            if (this.productData?.discount !== 0) {
                totalBeforeDiscounts *= (1 - (this.productData.discount / 100));
            }

            if(this.branchDiscount !== 0){
                totalBeforeDiscounts = totalBeforeDiscounts * (1 - this.branchDiscount);
            }
            // Calculate final total for the quantity
            const total = totalBeforeDiscounts * this.quantity;
            this.totalPriceRetail =  Math.ceil(total)
            return this.totalPriceRetail;
        },
        GetAttributesFromCart(){
            this.cartID = this.productItem.id;
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.APIREQUESTS.user.getAttributesFromCart.url + '/' + this.cartID + '/attributes',
                method: this.APIREQUESTS.user.getAttributesFromCart.method,
            })
            .then((res) => {
                this.attributes = res.data;
                // this.attributesCart = Array(this.productItem.product.details.length).fill(res.data);
                this.attributesSelectedCart = JSON.parse(localStorage.getItem('getOrderData')).attributes.map(attr => attr.id);
                this.attributes.map(attr => {
                    attr.children.map(child => {
                        if (this.attributesSelectedCart.includes(child.id)) {
                            child.isSelected = true;
                        } else {
                            child.isSelected = false;
                        }
                    });
                    return attr;
                }); 
     
            })
            .catch((err) => {
                console.error("err", err);
            })
        },
        createOrderDetails(){
            this.isSelected = false;            
            if(this.productData.product_type === 'retail'){
               return this.isNewOrder === true ? this.confirmActionForAdd() : this.confirmAction()
            }else if(this.productData.product_type === 'wholesale'){
                const activeWholesaleDetail = this.productData?.wholesale_details?.find(detail => detail.from_quantity <= this.quantity && detail.to_quantity >= this.quantity || detail.from_quantity <= this.quantity && detail.to_quantity === -1);
                if (!activeWholesaleDetail) {
                    this.notify({ type: 'error', msg: this.$t('general.quantity_not_in_range_wholesale', { quantity: this.productData.wholesale_details[0].from_quantity }) });
                    return;
                }
                return this.isNewOrder === true ? this.confirmActionForWholesaleAdd() : this.confirmActionForWholesale()
            }else if(this.$route.query.productItem){
                return this.confirmActionEditedOrder()
            }else{
                //
            }
        },
        confirmActionEditedOrder(){
            const selectedAttributes = this.getSelectedAttributes();
            const selectedAttributesID = selectedAttributes.map(attr => attr.children.map(child => child.id)).flat()
            const getDetailsID = JSON.parse(localStorage.getItem('getOrderData')).id
            const FormData =JSON.stringify( {
                detail_id: getDetailsID,
                quantity: this.quantity,
                attribute_ids: selectedAttributesID
            })
            this.makeRequest({
                owner: this.MAINROLES.user,
                url: this.APIREQUESTS.user.editDetailsOrder.url + '/' + this.productItem.id,
                method: this.APIREQUESTS.user.editDetailsOrder.method,
                formData: FormData
            })
            .then((res) => {
                if(res.status){
                    this.notify({type: 'success', msg: this.$t('general.order_updated_successfully')});
                    this.$emit('confirmActionEditedOrder', res.data);
                    this.$router.push('/cart');
                }else{
                    this.notify({type: 'error', msg: res.message});
                }
            })
            .catch((err) => {
                this.notify({type: 'error', msg: err.message});
            })
        },
        confirmActionForWholesaleAdd(){
            if (!this.validateAllAttributesSelected()) {
                this.notify({ type: 'error', msg: this.$t('general.select_all_attributes') });
                return; // Stop execution if validation fails
            }
            this.productDataWholesale = useGlobalStore().productData;
            this.orderDetailsDataWholesale = useGlobalStore().orderDetailsWholesale;
            const selectedAttributes = this.getSelectedAttributes();
            let existingOrderIndex = -1;
            // Check if the selected attributes already exist in orderDetailsData
            const minQuantity = parseInt(localStorage.getItem('minQuantity'), 10);
            if(this.quantity < minQuantity && minQuantity !== null){
                this.notify({type: 'error', msg: this.$t('general.min_quantity_is') + minQuantity});
                return;
            }
            if(this.orderDetailsDataWholesale.length > 0){
            existingOrderIndex = this.orderDetailsDataWholesale?.findIndex(order => 
                order?.attributes_products &&
                JSON.stringify(
                order?.attributes_products?.map(attr => attr.id)
                ) === JSON.stringify(
                    selectedAttributes?.map(attr => 
                    attr?.children?.filter(child => child?.isSelected).map(child => child.id)
                    ).flat()
                )
            );
            }
                
                if(existingOrderIndex !== -1){
                    // If found, increase the quantity of the existing order
                    // this.quantity = this.orderDetailsDataWholesale[existingOrderIndex].quantity + this.quantity;
                    this.orderDetailsDataWholesale[existingOrderIndex].quantity += this.quantity;
                    this.globalStore.setOrderDetailsWholesale(this.orderDetailsDataWholesale);
                    this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
                }else{
                    // If not found, create a new orderDetails object
                    const orderDetails = {
                        id: Date.now(),
                        quantity: this.quantity,
                        attributes: selectedAttributes,
                        productData: this.productDataWholesale
                    };

                    // New code to flatten attributes and assign to order.attributes_products
                    orderDetails.attributes_products = selectedAttributes.flatMap(attribute => 
                        attribute.children.map(child => ({
                            ...child,
                            name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                        }))
                    );
                    this.orderDetailsDataWholesale.push(orderDetails);
                    this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
                    this.globalStore.setOrderDetailsWholesale(this.orderDetailsDataWholesale);
                }
            this.changeOrderModalState(false);
            localStorage.setItem('minQuantity',null);
            this.$emit('confirmActionForWholesaleAdd', this.orderDetailsDataWholesale);
        },
        getSelectedAttributes() {
            return this.attributes
                .map(attr => ({
                    ...attr,
                    children: attr.children.filter(child => child.isSelected || child.is_selected),
                    name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en
                }))
                .filter(attr => attr.children.length > 0); // Only include attributes with selected children
        },
        confirmActionForAdd(){
            // localStorage.setItem('branch', JSON.stringify(this.branchData));
            if (!this.validateAllAttributesSelected()) {
                this.notify({ type: 'error', msg: this.$t('general.select_all_attributes') });
                return; // Stop execution if validation fails
            }
            const selectedAttributes = this.getSelectedAttributes();
            this.orderDetailsData = this.globalStore.orderDetails;

            // Check if the selected attributes already exist in orderDetailsData
            const existingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(
                    order.attributes_products.map(attr => attr.id)
                ) === JSON.stringify(
                    selectedAttributes.map(attr => 
                    attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );

            if(existingOrderIndex !== -1){
                // If found, increase the quantity of the existing order
                this.quantity = this.orderDetailsData[existingOrderIndex].quantity + this.quantity;
                this.orderDetailsData[existingOrderIndex].quantity += this.quantity;
            }else{
                // If not found, create a new orderDetails object
                const orderDetails = {
                    id: Date.now(),
                    quantity: this.quantity,
                    attributes: selectedAttributes,
                    productData: this.productData
                };

                // New code to flatten attributes and assign to order.attributes_products
                orderDetails.attributes_products = selectedAttributes.flatMap(attribute => 
                    attribute.children.map(child => ({
                        ...child,
                        name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                    }))
                );

                this.orderDetailsData.push(orderDetails);
            }
            this.quantity = this.isNewOrder === true ? 1 : parseInt(this.QuantityBeforeEdit, 10);
            this.globalStore.setOrderDetails(this.orderDetailsData);
            this.$emit('confirmActionForAdd', this.orderDetailsData);
            this.changeOrderModalState(false);
            this.isSelected = false;
        },
        confirmActionForWholesale() {
            this.isSelected = false;
            this.orderDetailsData = this.globalStore.orderDetailsWholesale;
            const selectedAttributes = this.getSelectedAttributes();
            // Find the index of the current order with matching selected attributes
            const matchingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(order.attributes_products.map(attr => attr.id)) === 
                JSON.stringify(
                    selectedAttributes.map(attr => 
                        attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );

            // Find the index of the order before editing
            const currentOrderIndex = this.orderDetailsData.findIndex(order => 
                order.id === parseInt(localStorage.getItem('orderID'), 10)
            );
            // if statement to check if the matchingOrderIndex exists or not if it exists then check if the currentOrderIndex is the same as the matchingOrderIndex
            // if it is the same then update the quantity and attributes and attributes_products
            // if it is not the same then update the quantity and attributes and attributes_products
            if(currentOrderIndex === matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                // this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // if the matchingOrderIndex does not exist then do nothing
            // (New Attributes) For the case where not exists mathcing, just update the quantity and new attributes
            if(matchingOrderIndex === -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                // this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists
            // and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // and remove the currentOrderIndex from the orderDetailsData
            // This for the case of matching the attributes and then add a new quantity to the matchingOrderIndex
            if(matchingOrderIndex !== -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[matchingOrderIndex].quantity += this.quantity;
                // this.orderDetailsData[matchingOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[matchingOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.orderDetailsData = this.orderDetailsData.filter(item => item !== this.orderDetailsData[currentOrderIndex])
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            this.$emit('confirmActionForWholesale');
            localStorage.removeItem('QuantityBeforeEdit');
            this.changeOrderModalState(false);
            this.$destroy();
        },
        confirmAction() {
            this.isSelected = false;
            this.orderDetailsData = this.globalStore.orderDetails;
            const selectedAttributes = this.getSelectedAttributes();

            // Find the index of the current order with matching selected attributes
            const matchingOrderIndex = this.orderDetailsData.findIndex(order => 
                order.attributes_products &&
                JSON.stringify(order.attributes_products.map(attr => attr.id)) === 
                JSON.stringify(
                    selectedAttributes.map(attr => 
                        attr.children.filter(child => child.isSelected).map(child => child.id)
                    ).flat()
                )
            );
            // Find the index of the order before editing
            const currentOrderIndex = this.orderDetailsData.findIndex(order => 
                order.id === parseInt(localStorage.getItem('orderID'), 10)
            );
            // if statement to check if the matchingOrderIndex exists or not if it exists then check if the currentOrderIndex is the same as the matchingOrderIndex
            // if it is the same then update the quantity and attributes and attributes_products
            // if it is not the same then update the quantity and attributes and attributes_products
            if(currentOrderIndex === matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                // this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // if the matchingOrderIndex does not exist then do nothing
            // (New Attributes) For the case where not exists mathcing, just update the quantity and new attributes
            if(matchingOrderIndex === -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[currentOrderIndex].quantity = this.quantity;
                // this.orderDetailsData[currentOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[currentOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            // if statement to check if the matchingOrderIndex exists
            // and if the currentOrderIndex is not the same as the matchingOrderIndex
            // if it is not the same then update the quantity and attributes and attributes_products
            // and remove the currentOrderIndex from the orderDetailsData
            // This for the case of matching the attributes and then add a new quantity to the matchingOrderIndex
            if(matchingOrderIndex !== -1 && currentOrderIndex !== matchingOrderIndex){
                this.orderDetailsData[matchingOrderIndex].quantity += this.quantity;
                // this.orderDetailsData[matchingOrderIndex].attributes = selectedAttributes;
                // this.orderDetailsData[matchingOrderIndex].attributes_products = selectedAttributes.flatMap(attribute => 
                //     attribute.children.map(child => ({
                //         ...child,
                //         name: this.currentLanguage === 'ar' ? child.name_ar : child.name_en,
                //     }))
                // );
                this.orderDetailsData = this.orderDetailsData.filter(item => item !== this.orderDetailsData[currentOrderIndex])
                this.globalStore.setOrderDetails(this.orderDetailsData);
            }
            this.$emit('confirmAction');
            localStorage.removeItem('QuantityBeforeEdit');
            this.changeOrderModalState(false);
            this.$destroy();
        },
        validateQuantity(event) {
            let value = parseInt(event.target.value, 10);
            // Prevent negative values or empty input
            if (value < 1 || isNaN(value)) {
                value = 1;
            }
            // Update the model value
            this.quantity = value;
        },
        changeSelect(mainId, subId) {
            this.attributes = this.attributes.map((item) => {
                if(item.id == mainId) {
                    // Clear error when making a selection
                    item.showError = false;
                    
                    item.children = item.children.map((child) => {
                        if(child.id == subId){
                            child.isSelected = true;
                        }else{
                            child.isSelected = false;
                        }
                        return child
                    })
                }
                this.productData.product_type === 'retail' ? this.calculateTotalPrice(): this.calculateTotalPriceWholesale();
                return item
            })
        },
        changeSelectForEdit(mainId, subId) {
            this.attributes = this.attributes.map((item) => {
                if(item.id == mainId ){
                item.children = item.children.map((child)=>{
                    if(child.id == subId){
                        if(this.$route.query.productItem){
                            child.isSelected = true;
                        }else{
                            child.is_selected = true;
                        }
                    }else{
                        if(this.$route.query.productItem){
                            child.isSelected = false;
                        }else{
                            child.is_selected = false;
                        }
                    }
                    return child
                })
                }
                return item;
            });
        },
        increaseQuantity() {
            this.quantity = this.quantity + 1;
            this.productData.product_type === 'retail' ? this.calculateTotalPrice(): this.calculateTotalPriceWholesale();
        },

        decreaseQuantity() {
            if(this.quantity > 1){
                this.quantity = this.quantity - 1;
            }
            this.productData.product_type === 'retail' ? this.calculateTotalPrice(): this.calculateTotalPriceWholesale();
        },
        updateAttributesFromProductData(newVal) {
            if (newVal && newVal.attributes && this.editedOrder.length === 0) {
                if(this.isNewOrder === false){
                    this.quantity = parseInt(this.QuantityBeforeEdit, 10);
                }
                this.attributes = newVal.attributes.map(attr => {
                    return {
                        ...attr,
                        name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en,
                        display_as_text: attr.display_as_text,
                        attributes_selected: attr.attributes_selected,
                        children: attr.children.map(child => ({
                            ...child,
                            isSelected: this.isNewOrder ? false : child.isSelected,
                            isColor: child.color !== null, // Determine if it's a color
                        }))
                    };
                });
            }
        },
        updateAttributesFromOrderData(newVal) {
            if (newVal && newVal.attributes && this.editedOrder.length === 0) {
                this.attributes = newVal.attributes.map(attr => {
                    return {
                        ...attr,
                        name: this.currentLanguage === 'ar' ? attr.name_ar : attr.name_en,
                        display_as_text: attr.display_as_text,
                        children: attr.children.map(child => ({
                            ...child,
                            isColor: child.color !== null, // Determine if it's a color
                            isSelected: this.isNewOrder ? false : child.isSelected  // Use isSelected from order data
                        }))
                    };
                });
            }
        },
        navToConfirmOrder() {
            if (this.actualFromCartBoolean && this.$refs.confirmOrderButton) {
                this.$nextTick(() => {
                    this.$refs.confirmOrderButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
                });
            }
        },
    },
    watch: {
        productData: {
            immediate: true,
            handler(newVal) {
                if(this.$route.query.productItem){
                    //
                }else{
                    this.updateAttributesFromProductData(newVal);
                }
            }
        },
        orderData: {
            immediate: true,
            handler(newVal) {
                if(this.$route.query.productItem){
                    //
                }else{
                    this.updateAttributesFromOrderData(newVal);
                }
            }
        },
        isOrderFormModalOpen: {
            handler(newVal) {
                if (newVal && this.actualFromCartBoolean) {
                    // Use setTimeout to ensure DOM is ready
                    setTimeout(() => {
                        this.navToConfirmOrder();
                    }, 100);
                }
            }
        },
        fromCartBoolean: {
            handler(newVal) {
                // When prop changes, check if we need to scroll
                if (this.isOrderFormModalOpen && (newVal || this.actualFromCartBoolean)) {
                    setTimeout(() => {
                        this.navToConfirmOrder();
                    }, 100);
                }
            }
        }
    },
    mounted() {
        this.fromCart = localStorage.getItem('fromCart');
        if (this.changeOrderModalState === false && this.editedOrder.length === 0 && !this.$route.query.productItem){
            setTimeout(() => {
                this.$destroy();
                localStorage.removeItem('QuantityBeforeEdit');
            }, 2000);
        }
        if(this.isNewOrder === true && !this.$route.query.productItem){
            this.isSelected = false;
            this.quantity = 1;
            this.attributes = this.productData.attributes;
            this.attributes.forEach(attr => {
                    attr.children.forEach(child => {
                    child.isSelected = false; // Reset each child's isSelected property
                });
            });
        }else if(this.isNewOrder === false && this.editedOrder.length === 0 && !this.$route.query.productItem){
            this.quantity = parseInt(this.QuantityBeforeEdit, 10);
        }else if(this.$route.query.productItem){
            this.quantity = parseInt(this.editedOrder.quantity, 10);
            this.productItem = this.$route.query.productItem;
            this.productItem = JSON.parse(decodeURIComponent(atob(decodeURIComponent(this.productItem))));
            this.GetAttributesFromCart();
            this.getOrderData = JSON.parse(localStorage.getItem('getOrderData'));
            this.quantity = parseInt(JSON.parse(localStorage.getItem('getOrderData')).quantity, 10);
            this.productName = this.currentLanguage === 'ar' ? this.productItem.product.name_ar : this.productItem.product.name_en;
            this.productImage = this.productItem.product.image;
        }

        if(this.attributes && this.isNewOrder === true) {
            this.attributes = this.attributes.map(attr => ({
                ...attr,
                showError: false 
            }));
        }
        const attributeSelections = this.attributes.map(attr => attr.children.map(child => child.isSelected));
        attributeSelections.forEach((childArray, attrIndex) => {
            if (childArray.every(val => val === false) && childArray.length === 1 && this.isNewOrder === true) {
                this.attributes[attrIndex].children[0].isSelected = true;
            }
        });
        
        // Scroll to confirm button if fromCartBoolean is true
        if (this.actualFromCartBoolean && this.isOrderFormModalOpen) {
            this.navToConfirmOrder();
        }
    }
}
</script>

<style></style>